window.pulse = (event, item, color) => {
	const el = document.createElement("div");
	el.classList = "absolute circle";
	if(color) el.style.backgroundColor = color;

	const rect = event.target.getBoundingClientRect()
	let cursorX = event.clientX - rect.left
	let cursorY = event.clientY - rect.top

	el.style.top = `${cursorY}px`;
	el.style.left = `${cursorX}px`;
	item.appendChild(el);
	setTimeout(() =>  el.remove(), 3000)
}

(() => {
	const defaultFontSize = 16;
	let pageFontSize = Number(localStorage.getItem('pageFontSize')) || defaultFontSize;
	document.body.style.fontSize = `${Number(pageFontSize) / 10}rem`;

	const buttons = document.querySelectorAll('.js-font-size-changer');
	if (pageFontSize < defaultFontSize) {
		buttons[0].classList.add('is-active');
		buttons[0].setAttribute('aria-pressed', true);
	}
	if (pageFontSize > defaultFontSize) {
		buttons[1].classList.add('is-active');
		buttons[1].setAttribute('aria-pressed', true);
	}

	window.changeFontSize = (event, inc) => {
		buttons.forEach(x => {
			x.classList.remove('is-active');
		});

		if (inc != pageFontSize) {
			event.target.classList.add('is-active')
			event.target.setAttribute('aria-pressed', true);
			pageFontSize = inc;
		}
		else if (inc == pageFontSize) {
			pageFontSize = defaultFontSize;
			event.target.classList.remove('is-active');
			event.target.setAttribute('aria-pressed', false);
		}

		localStorage.setItem('pageFontSize', pageFontSize)
		document.body.style.fontSize = `${Number(pageFontSize) / 10}rem`;
	}
})();

(() => {
	// console.log('init contrast');
	const buttons = document.querySelectorAll('.js-contrast-changer');
	const defaultClasses = document.body.className;

	let pageContrast = localStorage.getItem('pageContrast') || '';
	if (pageContrast) {
		document.body.className = `${defaultClasses} ${pageContrast}`;
		// console.log(`active contrast: ${pageContrast}`);

		buttons.forEach(button => {
			if (button.dataset.contrast == pageContrast) {
				button.classList.add('is-active')
				button.setAttribute('aria-pressed', true);
			}
			else {
				button.classList.remove('is-active')
				button.setAttribute('aria-pressed', false);
			}
		});
	}
	else if (window.matchMedia("(prefers-contrast: more)").matches) {
		document.body.className = `${defaultClasses} ${buttons[1].dataset.contrast}`;
		buttons[1].classList.add('is-active')
		buttons[1].setAttribute('aria-pressed', true);
	}
	else {
		buttons[0].classList.add('is-active')
		buttons[0].setAttribute('aria-pressed', true);
	}

	window.changePageColors = (contrast) => {
		localStorage.setItem('pageContrast', contrast)
		document.body.className = `${defaultClasses} ${contrast}`;

		buttons.forEach(button => {
			if (button.dataset.contrast == contrast) {
				button.classList.add('is-active')
				button.setAttribute('aria-pressed', true);
			}
			else {
				button.classList.remove('is-active')
				button.setAttribute('aria-pressed', false);
			}
		});
	}
})();
